"use client";
import UserType from "src/api/graphql/__generated__/enums/UserType";
import { GatheringInitialEntryFragmentFragment } from "src/api/graphql/__generated__/graphql";
import Loading from "src/components/Loading";
import native from "src/constants/native";
import hasValidGatheringAccess from "src/helpers/gatheringHelpers/hasValidGatheringAccess";
import { LoginModalConfig } from "src/modals/configs/LoginModal";
import RootModalContainer from "src/modals/containers/RootModalContainer";
import useGlobalStore from "src/stores/useGlobalStore";
import Gathering404 from "../(error)/Gathering404";
import useQueryGatheringEntry from "./hooks/useQueryGatheringEntry";
import GatheringEntryLoggedIn from "./screens/GatheringEntryLoggedIn";
import GatheringPreview from "./screens/GatheringPreview";

const GatheringEntry = ({
	gathering: gatheringProp,
}: {
	gathering?: GatheringInitialEntryFragmentFragment;
}) => {
	const hasFullAccount = useGlobalStore(
		(state) => state.loggedIn && state.userType === UserType.Full,
	);
	const { gathering, loading, identifier } = useQueryGatheringEntry(gatheringProp);

	const isWaitingGatheringAccessInfo =
		(!gathering || !hasValidGatheringAccess(gathering)) && loading && hasFullAccount;
	const isWaitingGatheringInfo = !gathering && loading;

	if (isWaitingGatheringAccessInfo || isWaitingGatheringInfo) {
		return <Loading variant="Screen" />;
	}
	if (!gathering) {
		return (
			<Gathering404
				toastConfig={{
					identifier,
				}}
			/>
		);
	}
	if (!hasFullAccount) {
		return (
			<>
				<GatheringPreview gathering={gathering} />
				{!native && <RootModalContainer config={LoginModalConfig} />}
			</>
		);
	}
	return <GatheringEntryLoggedIn gathering={gathering} />;
};
export default GatheringEntry;
